import { render, staticRenderFns } from "./BookQrCode.vue?vue&type=template&id=04ca839a"
import script from "./BookQrCode.vue?vue&type=script&lang=js"
export * from "./BookQrCode.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports